import type { ReactElement, ReactNode } from "react";
import styles from "./Card.module.css";

export interface CardProps {
  children: ReactNode;
  as?: "section" | "article" | "div";
  className?: string;
}

export function Card({
  children,
  as: Tag = "section",
  className,
}: CardProps): ReactElement {
  return (
    <Tag className={[styles.card, className].filter(Boolean).join(" ")}>
      {children}
    </Tag>
  );
}
